module.exports = __webpack_public_path__ + "img/icon14.45507eb.png";